import { createSlice } from '../../core';
import type { Point2D } from '../../core/utils';

type CursorTrackingState = {
  contentPoint: Point2D | null;
  screenPoint: Point2D | null;
};

const defaultState: CursorTrackingState = {
  contentPoint: null,
  screenPoint: null,
};

export type CursorTrackingSlice = {
  cursorTracking: {
    state: CursorTrackingState;
    actions: {
      setState: (state: CursorTrackingState) => void;
    };
  };
};

export const createCursorTrackingSlice = createSlice()<CursorTrackingSlice>(
  set => ({
    cursorTracking: {
      state: defaultState,
      actions: {
        setState: state => {
          set(root => ({
            ...root,
            cursorTracking: {
              ...root.cursorTracking,
              state,
            },
          }));
        },
      },
    },
  })
);
